export { Profesional } from './profesional';
export { PlanTratamientoRespuesta } from './plan-tratamiento-respuesta';
export { HojaDeConsulta } from './hojadeconsulta';
export { Alergia } from './alergia';
export { Farmaco } from './farmaco';
export { Vacuna } from './vacuna';
export { Dosis } from './dosis';
export { Habito } from './habito';
export { Documento } from './documento';
export { Constante } from './constante';
export { Motivo } from './motivo';
export { Anamnesis } from './anamnesis';
export { Exploracion } from './exploracion';
export { Cita } from './cita';
export { Diagnostico } from './diagnostico';
export { TecnicaTerapeutica } from './tecnicaterapeutica';
export { TecnicaDiagnostica } from './tecnicadiagnostica';
export { JuicioDiagnostico } from './juiciodiagnostico';
export { PlanActuacion } from './planactuacion';
export { Nota } from './nota';
export { Patron } from './patron';



// WEBPACK FOOTER //
// ./src/models/index.ts